export * from "./hotel-remarks.component";
